import { http, HttpResponse } from "msw";
import { apiPaths } from "../../api-paths.js";
import type {
  Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_Failed,
  Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_NotFound,
  Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_Success,
  Trips_SubmitModificationCheckout_SubmitModificationCheckoutFailedReason,
} from "../../swagger-types/v1/index.js";

const createSubmitModificationCheckoutSuccessMock = (
  overrides: Partial<Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_Success> = {},
): Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_Success => ({
  modificationRequestId: 42,
  redirectUrl: null,
  ...overrides,
});

const createSubmitModificationCheckout200Handler = (
  response: Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_Success = createSubmitModificationCheckoutSuccessMock(),
) => [
  http.post(apiPaths.trips.modification.submitCheckout, async () => {
    return HttpResponse.json(response, { status: 200 });
  }),
];

const createSubmitModificationCheckout404Handler = [
  http.post(apiPaths.trips.modification.submitCheckout, async () => {
    const responseBody: Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_NotFound = {};
    return HttpResponse.json(responseBody, { status: 404 });
  }),
];

const createSubmitModificationCheckout422Handler = (
  failedReason: Trips_SubmitModificationCheckout_SubmitModificationCheckoutFailedReason,
) => [
  http.post(apiPaths.trips.modification.submitCheckout, async () => {
    const responseBody: Trips_SubmitModificationCheckout_SubmitModificationCheckoutCommandResponse_Failed = {
      failedReason,
    };
    return HttpResponse.json(responseBody, { status: 422 });
  }),
];

const createSubmitModificationCheckout500Handler = [
  http.post(apiPaths.trips.modification.submitCheckout, async () => {
    return HttpResponse.json({}, { status: 500 });
  }),
];

export const submitModificationCheckoutHandlers = {
  post200: createSubmitModificationCheckout200Handler(),
  post404: createSubmitModificationCheckout404Handler,
  post500: createSubmitModificationCheckout500Handler,
} as const;

export const submitModificationCheckoutHandlersFactory = {
  create200: createSubmitModificationCheckout200Handler,
  create422: createSubmitModificationCheckout422Handler,
  createSuccessMock: createSubmitModificationCheckoutSuccessMock,
} as const;
